import * as React from 'react'
import clsx from 'clsx'
import Link from 'next/link'

import { Shimmer } from '@wartek-id/shimmer'
import { Avatar } from '@wartek-id/avatar'

import { assetUrl } from 'utils/url'

interface AssessmentCardProps {
  loading?: boolean
  src: string
  title: string
  time: string | number
  numQuestions: string | number
  phase: string
  subjects: string
  className?: string
  href?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const AssessmentCard = (props: AssessmentCardProps) => {
  const {
    loading = true,
    src,
    title,
    numQuestions,
    phase,
    subjects,
    time,
    className,
    href,
    onClick,
  } = props

  const classes = clsx(
    className,
    'w-full flex flex-row rounded-lg py-4 px-3 bg-white shadow-md hover:shadow-lg transition-shadow focus:bg-[#EDEDED] focus:outline-none focus:shadow-none'
  )

  const loadingComp = (
    <div className={classes} tabIndex={0}>
      <div>
        <Shimmer width={40} height={40} rounded />
      </div>
      <div className="flex flex-col ml-3">
        <Shimmer width={186} className="mb-2" style={{ borderRadius: 100 }} />
        <Shimmer width={133} className="mb-2" style={{ borderRadius: 100 }} />
        <Shimmer width={96} className="mt-2" style={{ borderRadius: 100 }} />
      </div>
    </div>
  )

  return loading ? (
    loadingComp
  ) : (
    <Link href={href} passHref>
      <div className={classes} tabIndex={0} onClick={onClick}>
        <Avatar src={src} name={title} size="md" alt="" />
        <div className="flex flex-col ml-3 flex-1">
          <h2 className="text-base font-semibold mb-1">{title}</h2>
          <div className="mb-3 text-sm flex items-center text-[#52575C]">
            <div className="flex items-center w-24">
              <img
                className="w-4 h-4"
                src={assetUrl('/icon/lists.svg')}
                alt=""
              />
              <span className="ml-1">{numQuestions} soal</span>
            </div>
            <div className="flex-1 flex items-center">
              <img
                className="w-4 h-4"
                src={assetUrl('/icon/timer.svg')}
                alt=""
              />
              <span className="ml-1">{time} menit pengerjaan</span>
            </div>
          </div>

          <div className="text-xs text-[#92989E]">
            <span>{phase}</span>
            <span className="mx-3">|</span>
            <span>{subjects}</span>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default AssessmentCard
